/**
 * @generated SignedSource<<e6f06f909b78524dd79382eede604947>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CreativeAdvisorBrand$data = {
  readonly insights: ReadonlyArray<{
    readonly id: string;
    readonly text: string;
    readonly " $fragmentSpreads": FragmentRefs<"CreativeAdvisorInsight">;
  }> | null;
  readonly name: string;
  readonly " $fragmentType": "CreativeAdvisorBrand";
};
export type CreativeAdvisorBrand$key = {
  readonly " $data"?: CreativeAdvisorBrand$data;
  readonly " $fragmentSpreads": FragmentRefs<"CreativeAdvisorBrand">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CreativeAdvisorBrand",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Insight",
      "kind": "LinkedField",
      "name": "insights",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "text",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "CreativeAdvisorInsight"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Brand",
  "abstractKey": null
};

(node as any).hash = "e0b4534c906bed8ee4d5264ea755595c";

export default node;
